import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { getCompanyData, updateCompany } from '../../services/Company/companyService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import DocumentInput from '../Utils/DocumentInput';
import PhoneInput from '../Utils/PhoneInput';
import ZipCodeInput from '../Utils/ZipCodeInput';
import InputField from '../Utils/InputField';
import UFSelect from '../Utils/UFSelect';

const EditCompanyModal = ({ show, handleClose, company, refreshCompanies }) => {
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch, control } = useForm();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [modalKey, setModalKey] = useState(0);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        if (company?.id) {
          const data = await getCompanyData(company.id);
          setValue('name', data.name);
          setValue('document', data.document);
          setValue('registration', data.registration);
          setValue('businessPhone', data.businessPhone);
          setValue('cellPhone', data.cellPhone);
          setValue('address', data.address);
          setValue('district', data.district);
          setValue('city', data.city);
          setValue('state', data.state);
          setValue('zipCode', data.zipCode);
        }
      } catch (error) {
        setErrorMessage(error.message || 'Erro ao buscar dados da empresa.');
        setShowErrorModal(true);
      }
    };

    if (show && company) {
      fetchCompanyData();
    } else if (!show) {
      reset();
      setModalKey((prevKey) => prevKey + 1);
    }
  }, [show, company, setValue, reset]);

  const onSubmit = async (data) => {
    const payload = {
      name: data.name,
      document: data.document,
      registration: data.registration,
      businessPhone: data.businessPhone,
      cellPhone: data.cellPhone,
      address: data.address,
      district: data.district,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
    };

    try {
      await updateCompany(company.id, payload);
      setSuccessMessage('Empresa atualizada com sucesso!');
      setShowSuccessModal(true);
      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao atualizar empresa.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshCompanies();
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Editar Empresa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col md={8}>
                <InputField
                  label="Nome"
                  name="name"
                  placeholder="Digite o nome"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Nome é obrigatório' }}
                />
              </Col>
              <Col md={4}>
                <DocumentInput
                  key={modalKey}
                  label="CPF/CNPJ"
                  name="document"
                  register={register}
                  errors={errors}
                  value={watch('document')}
                  rules={{ required: 'Documento é obrigatório' }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Inscr. Estadual"
                  name="registration"
                  placeholder="Digite a Inscrição Estadual"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col md={6}>
                <PhoneInput
                  key={modalKey}
                  label="Telefone Comercial"
                  name="businessPhone"
                  register={register}
                  errors={errors}
                  value={watch('businessPhone')}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <PhoneInput
                  key={modalKey}
                  label="Telefone Celular"
                  name="cellPhone"
                  register={register}
                  errors={errors}
                  value={watch('cellPhone')}
                />
              </Col>
              <Col md={6}>
                <ZipCodeInput
                  label="CEP"
                  name="zipCode"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Endereço"
                  name="address"
                  placeholder="Digite o endereço"
                  register={register}
                  errors={errors}
                />
              </Col>
              <Col md={6}>
                <InputField
                  label="Bairro"
                  name="district"
                  placeholder="Digite o bairro"
                  register={register}
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <InputField
                  label="Cidade"
                  name="city"
                  placeholder="Digite a cidade"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Cidade é obrigatória' }}
                />
              </Col>
              <Col md={6}>
                <Controller
                  name="state"
                  control={control}
                  defaultValue=""
                  rules={{ required: 'Estado é obrigatório' }}
                  render={({ field, fieldState }) => (
                    <UFSelect
                      label="Estado"
                      {...field}
                      errors={errors}
                      isInvalid={!!fieldState.error}
                    />
                  )}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Atualizar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default EditCompanyModal;